import React, { useEffect, useCallback, useContext } from 'react';
import {
  Box,
  Grid,
  Button,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Checkbox,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Field } from 'react-final-form';

import AuthContext from '../../contexts/authContext';

// import imgBtnLogin from '../../res/images/btn_login.gif';
// import imgTxtLogin from '../../res/images/txt_login.gif';
import imgLoginTitle from '../../res/images/login_title.png';
// import imgBgLogin from '../../res/images/bg_login.gif';
import '../../res/css/loginForm.css';

import {
  loginUser,
  //  setLocalStorageToken
} from '../../actions';

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);

  const { data, error } = useSelector((state) => state.user.login);

  const onSubmit = useCallback(
    ({ username, password }) => {
      // console.log('username', username);
      // console.log('password', password);
      const user = { username, password };
      dispatch(loginUser(user));
      // authContext.login();
    },
    [dispatch]
  );

  useEffect(() => {
    console.log('data', data);
    if (data && data.token) {
      authContext
        .login(data)
        .then(() => {
          navigate('/');
        })
        .catch((e) => {
          window.alert(e);
        });
    }
  }, [data, authContext, navigate]);

  useEffect(() => {
    console.log('error', error);
  }, [error]);

  return (
    <Form
      onSubmit={onSubmit}
      // validate={(values) => {
      //   const errors = {};
      //   if (!values.username) {
      //     errors.username = '필수';
      //   }
      //   if (!values.password) {
      //     errors.password = '필수';
      //   }
      //   return errors;
      // }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <form onSubmit={handleSubmit} id="login_form">
            <div id="login" className="valign-wrapper">
              <div className="container">
                <Box sx={{ width: '645px', mb: 2 }}>
                  <Grid container sx={{ height: '52px', width: '100%' }}>
                    <Grid item xs="auto">
                      <img src={imgLoginTitle} alt="로그인 타이틀" />
                    </Grid>
                    <Grid
                      item
                      sx={{ height: '100%', width: 'calc(100% - 222px)' }}
                    >
                      <Grid container sx={{ height: '100%', width: '100%' }}>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: '60%',
                            display: 'flex',
                          }}
                        >
                          <Box sx={{ alignSelf: 'flex-end' }}>
                            관리자 화면입니다
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: '40%',
                            fontSize: '0.7rem',
                            display: 'flex',
                          }}
                        >
                          <Box sx={{ alignSelf: 'flex-end', color: '#aaaaaa' }}>
                            관리자 계정 정보를 입력해주시고 관련 정보는 유출되지
                            않도록 보안사항을 지켜주세요.
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>

                <Box className="input-box-wrapper">
                  <Box className="input-box-header" />
                  <Grid container className="input-box">
                    <Grid item xs="auto" sx={{ mr: 1 }}>
                      <Grid item xs={12} sx={{ mb: 1 }}>
                        <Field name="username">
                          {({ input, meta }) => (
                            <Box>
                              <label className="form_label">아이디</label>
                              <input
                                {...input}
                                type="text"
                                placeholder="사용자 아이디"
                              />
                            </Box>
                          )}
                        </Field>
                      </Grid>
                      <Grid item xs={12}>
                        <Field name="password">
                          {({ input, meta }) => (
                            <Box>
                              <label className="form_label">비밀번호</label>
                              <input
                                {...input}
                                type="password"
                                placeholder="비밀번호"
                              />
                            </Box>
                          )}
                        </Field>
                      </Grid>
                    </Grid>
                    <Grid item xs="auto">
                      <Button
                        type="submit"
                        disabled={submitting}
                        variant="contained"
                      >
                        로그인
                      </Button>
                    </Grid>
                    {error && (
                      <Grid item xs={12}>
                        <FormHelperText sx={{ ml: '198px' }}>
                          아이디와 비밀번호를 확인해주세요.
                        </FormHelperText>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <FormGroup sx={{ ml: '198px' }}>
                        <FormControlLabel
                          control={<Checkbox defaultChecked size="small" />}
                          label="아이디 저장"
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </div>
          </form>
        </Box>
      )}
    />
  );
};

export default LoginForm;
